import React, { memo } from 'react';
import { X } from 'lucide-react';
interface LimitReachedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  onWaitForReset: () => void;
  resetDate: string;
  daysLeft: number;
}
export const LimitReachedModal = ({
  isOpen,
  onClose,
  onUpgrade,
  onWaitForReset,
  resetDate,
  daysLeft
}: LimitReachedModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-1289">
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50" onClick={onClose} data-id="element-1290"></div>
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative z-10 animate-fadeIn" data-id="element-1291">
        <div className="absolute top-4 right-4" data-id="element-1292">
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1293">
            <X className="w-5 h-5" data-id="element-1294" />
          </button>
        </div>
        <div className="p-6" data-id="element-1295">
          <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-1296">
            Monthly AI invocation limit reached
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-1297">
            You've used all 5 invocations included in your Free plan. Your limit
            resets on {resetDate} ({daysLeft} days).
          </p>
          <div className="border border-gray-200 rounded-md p-4 mb-6 bg-gray-50" data-id="element-1298">
            <div className="flex items-start mb-4" data-id="element-1299">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1300">
                <span className="text-gray-700 font-medium text-xl" data-id="element-1301">P</span>
              </div>
              <div data-id="element-1302">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-1303">
                  Premium Plan
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1304">
                  Upgrade to get 10x more invocations and unlock unlimited
                  custom instructions.
                </p>
              </div>
            </div>
            <div className="flex justify-between text-sm text-gray-700 mb-2" data-id="element-1305">
              <span data-id="element-1306">Monthly invocations</span>
              <span className="font-medium" data-id="element-1307">50</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700 mb-2" data-id="element-1308">
              <span data-id="element-1309">Custom instructions</span>
              <span className="font-medium" data-id="element-1310">Unlimited</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700" data-id="element-1311">
              <span data-id="element-1312">Agent memory</span>
              <span className="font-medium" data-id="element-1313">90 days</span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-end gap-3" data-id="element-1314">
            <button onClick={onWaitForReset} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1315">
              Wait for Reset
            </button>
            <button onClick={onUpgrade} className="px-4 py-2 bg-gray-800 text-white rounded-md text-sm font-medium hover:bg-gray-700 transition-colors" data-id="element-1316">
              Upgrade to Premium
            </button>
          </div>
        </div>
      </div>
    </div>;
};